export default {
  title: {
    id: 'landing_faq_thumb_title',
    defaultMessage: "You've scrolled quite a bit...",
  },
  text: {
    id: 'landing_faq_thumb_paragraph',
    defaultMessage: 'Still have doubts?',
  },
  buttonLabel: {
    id: 'landing_faq_thumb_button',
    defaultMessage: 'Jabber away',
  },
}
